import { mapGetters, mapActions } from 'vuex'
import modalStructure from '@/components/modals/modal-structure'

export default {
  components: {
    modalStructure
  },
  data: () => {
    return {
      showLogoutModal: false,
      showSettingsModal: false
    }
  },
  methods: {
    ...mapActions([
      'cleanStorage'
    ]),
    openLogoutModal () {
      this.showLogoutModal = true
    },
    cancelLogout () {
      this.showLogoutModal = false
    },
    logout () {
      this.cleanStorage()
    },
    reloadPage () {
      location.reload(true)
    }
  },
  computed: {
    ...mapGetters([
      'getterAccount'
    ])
  }
}
